import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { take, takeWhile } from 'rxjs/operators';

import { CdcLojaRestService } from '../../../../../omni-rest/cdc/cdc-loja-rest.service';
import { ModalMessageComponent } from '../../../../../shared/modais/modal-message/modal-message.component';

@Component({
  selector: 'app-mercadoria',
  templateUrl: './mercadoria.component.html',
  styleUrls: ['./mercadoria.component.scss']
})
export class MercadoriaComponent implements OnInit, OnDestroy {
  @Input() indentificacaoForm: FormGroup;
  @Input() index: number;
  @Input() valorDisabled?: boolean = false;
  @Input() valorLiquido: number;
  @Output() selfDestructEmitter: EventEmitter<number> = new EventEmitter();
  @ViewChild('modalMessage', { static: true }) modalMessage: ModalMessageComponent;

  mercadoriaForm: FormGroup;

  isAlive: boolean = true;
  isDisabled: boolean = true;

  mercadorias: any[];
  tiposMercadoria: any[];

  constructor(
    private cdcLojaRestService: CdcLojaRestService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.initForms();
    this.initObservers();
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  initForms(): void {
    this.mercadoriaForm = this.fb.group(
      {
        tiposMercadoria: ['', Validators.required],
        valorProduto: ['', Validators.required]
      },
      // { validator: this.valorProdutoMatcher }
    );

    this.indentificacaoForm.addControl(
      `mercadoriaForm_${this.index}`,
      this.mercadoriaForm
    );
  }

  initObservers(): void {
    this.cdcLojaRestService
      .get('mercadorias/tipos').pipe(
        takeWhile(() => this.isAlive))
      .subscribe((res) => (this.handleMercadoria(res)));
  }

  selfDestruct(): void {
    this.indentificacaoForm.removeControl(`mercadoriaForm_${this.index}`);
    this.selfDestructEmitter.emit(this.index);
  }

  handleMercadoria(res) {
    this.tiposMercadoria = res;
    this.filtraMercadoriaDell(this.tiposMercadoria);
  }

  filtraMercadoriaDell(mercadorias) {
    const mercadoria = mercadorias.filter(mercadoria => mercadoria.id === 11)[0];
    this.mercadoriaForm.controls['tiposMercadoria'].setValue(mercadoria.id);
    this.mercadoriaForm.controls['valorProduto'].setValue(this.valorLiquido);
    this.mercadoriaForm.disable();
  }

  get tipoMercadoria(): AbstractControl {
    return this.mercadoriaForm.get('tiposMercadoria');
  }

  get valorProduto(): AbstractControl {
    return this.mercadoriaForm.get('valorProduto');
  }
}
